const Articles = () => {
  return (
    <div className="p-8">
      <h1 className="text-3xl font-bold mb-4">Articles</h1>
      <p>Helpful industry articles will be added here.</p>
    </div>
  );
};

export default Articles;
